<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">{{kymw0700Model.titleValue}}</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">Ｐコード</label>
          <div class="list-input-content" style="width: 7rem;">
            <input type="text" id="lbl_PCode" [style.white-space]="'nowrap'" value="{{kymw0700Model.pCode}}" readonly>
          </div>
          <label class="list-input-title">商品名</label>
          <div class="list-input-content">
            <input type="text" id="lbl_GoodsName" [style.white-space]="'nowrap'"
              class="guide-goods-name" value="{{kymw0700Model.goodsName}}" readonly>
          </div>
          <label class="list-input-title">規格名</label>
          <div class="list-input-content">
            <input type="text" id="lbl_GuideStandardName" [style.white-space]="'nowrap'"
              class="guide-standard-name" value="{{kymw0700Model.guideStandardName}}" readonly>
          </div>
        </div>
        <!-- データグリッド定義 -->
        <wj-flex-grid #dg_TextInfoList id="dg_TextInfoList" [itemsSource]="kymw0700Model.textInfoList"
          [style.height.px]="420" [style.width.px]="757" [allowSorting]="false" [allowDragging]="'None'"
          [headersVisibility]="'Column'" (itemsSourceChanged)="doFilter()" [tabindex]="0" (pasting)="onPasting($event)">
          <!-- 表示項目 -->
          <wj-flex-grid-column [minWidth]="5" [header]="'　'" [binding]="'dispNum'" [width]="40" [align]="'right'"
            [isReadOnly]="true">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'selectedFlg'" [header]="'選択'" [align]="'center'"
            [isReadOnly]="true">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="checkbox" [(ngModel)]="cell.item.selectedFlg"
                [disabled]="sharedModel.kymw1001Model.formReadOnlyMode.get(parent.componentName)"
                (change)="changeHandler()" [tabindex]="0" (focus)="this.dg_TextInfoList.select(cell.row.index, 1);"
                id="cb_text_info_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="kymw0700Model.headerText" [binding]="'stringValue'"
            [width]="650">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
              <label [style.min-height.px]="68" [style.white-space]="'normal'">{{item.stringValue}}</label>
            </ng-template>
            <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
              <app-text-area [fullOnly]="true" [restrict]="'[ -￮]'" [displayCountField]="false"
                [(ngModel)]="cell.value" [disabled]="isReadOnly" (blur)="eventCheckNgWordHandler($event)"
                (keydown)="eventGridKeyDownHandler($event,dg_TextInfoList,2)" [tabindex]="-1">
              </app-text-area>
            </ng-template>
          </wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" id="btn_Set" [disabled]="!kymw0700Model.enabledSet"
            (click)="eventSet_CLICKHandler(null)" [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>